




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import AccountListCard from '@/components/member//memberList/MemberListBase.vue';
import ProfileDetailModal from '@/components/profile/ProfileDetailModalBase.vue';
import ProjectInviteMenu from '@/components/home/ProjectInviteMenu.vue';
import { ProjectMemberResponse } from '@/@types/ProjectMember';

@Component({
  components: {
    AccountIcon,
    AccountListCard,
    ProfileDetailModal,
    ProjectInviteMenu
  },
})
export default class MemberIconList extends Vue {
  private isOpenProfileDetailDrawer: boolean = false;
  private menu: string = '';
  private applicantListDialog: boolean = false;
  private avatarSize: number = 35;
  private avatarColor: string = 'rgb(250, 95, 126, 0.1)';
  private iconSize: number = 24;
  private iconColor: string = '#fa5f7e';

  @Prop({ required: true })
  private projectMembers!: ProjectMemberResponse[];

  @Prop({ required: true, default: true })
  private isProjectMemberLoading!: boolean;

  private get isProjectMemberLoadingNow() {
    return this.isProjectMemberLoading;
  }

  private openProfileDetailDrawer(): void {
    this.isOpenProfileDetailDrawer = true;
  }

  private closeProfileDetailDrawer(): void {
    this.isOpenProfileDetailDrawer = false;
  }

  private generateInitialName(fullName: string) {
    return fullName.slice(0, 1);
  }

  private get showProjectMembers() {
    return this.projectMembers.slice(0, 5);
  }

  private get isProjectMembersCountGreaterThanFive() {
    return this.projectMembers.length > 5 ? true : false;
  }
}
